var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-flat-accordion',{attrs:{"items":_vm.corpInfos,"expand-icon":"fas fa-chevron-down"},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var item = ref.item;
return [_c('invoice-corporation-header',{attrs:{"value":item.header}})]}},{key:"content",fn:function(ref){
var item = ref.item;
return [_c('invoice-corporation-content',{attrs:{"value":item.content},on:{"updateInvoiceStatus":_vm.updateInvoiceStatus}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }